import gsap from 'gsap';
import { Expo } from 'gsap';

//How log the word stay still
const offestWord = 0.2;
//movement duration
const durationWord = 1;
//how late the bottom animation starts with respect to the top animation
const delayBottom = 0.3;

function animateWords(wordsItems, length) {
    let timelineTop = gsap.timeline({ repeat: -1, delay: 0});
    let timelineBottom = gsap.timeline({ repeat: -1, delay: delayBottom});
    let tops = [];
    let bottoms = [];
    wordsItems.forEach(
        item => {
            Array.from(item.childNodes).forEach(
                child => {
                    child.className === 'words-item__top' && tops.push(child);
                    child.className === 'words-item__bottom' && bottoms.push(child);
                }
            )
        }
    );
    tops.forEach(
        top => {
            timelineTop.to(top, {
                y: 0,
                duration: durationWord,
                opacity: 1,
                ease: Expo.easeOut
            })
            timelineTop.to(top, {
                duration: offestWord
            })
            timelineTop.to(top, {
                y: -20,
                duration: durationWord,
                opacity: 0,
                ease: Expo.easeOut
            })
        });
    bottoms.forEach(
        bottom => {
            timelineBottom.to(bottom, {
                y: 0,
                duration: durationWord,
                opacity: 1,
                ease: Expo.easeOut
            })
            timelineBottom.to(bottom, {
                duration: offestWord
            })
            timelineBottom.to(bottom, {
                y: 20,
                duration: durationWord,
                opacity: 0,
                ease: Expo.easeOut
            })
        });
}

export function handleWords(wordsItems, length) {
    animateWords(wordsItems, length);
}